// Administración · Empresa (autogestión 2026-10-30 §2.2, T-17p9): logo de
// la empresa, logos y nombres de sus marcas, administrados por la propia
// organización bajo /organizations/me/*.
//
// Son las mismas formas de petición y respuesta que las rutas /admin/orgs/
// :id/* equivalentes (./admin.ts) — alias, no copias — para que el
// dashboard reutilice el flujo presign → PUT → commit de
// features/admin/logoUpload.ts cambiando sólo la URL. Lo que cambia es
// quién llama (quien administra la organización según la receta,
// lib/org-admin.ts en core-api) y que la organización sale del JWT, nunca
// de la URL.
//
// Rutas:
//   POST   /organizations/me/logo/upload-url                 → upload-url
//   POST   /organizations/me/logo/commit                     → {organization}
//   DELETE /organizations/me/logo                            → 204
//   POST   /organizations/me/brands                          → 201 {brand}
//   PATCH  /organizations/me/brands/:brandId                 → {brand}
//   POST   /organizations/me/brands/:brandId/logo/upload-url → upload-url
//   POST   /organizations/me/brands/:brandId/logo/commit     → {brand}
//   DELETE /organizations/me/brands/:brandId/logo            → 204
//
// Sin columnas nuevas: el correo de respuesta y el código de marca del
// handoff quedan diferidos (no se guardan en `config`).
import { z } from "zod";
import { adminBrandCreateRequestSchema, adminBrandLogoCommitRequestSchema, adminBrandLogoUploadUrlRequestSchema, adminBrandLogoUploadUrlResponseSchema, adminOrgLogoCommitResponseSchema, } from "./admin.js";
import { myOrganizationBrandSchema } from "./auth.js";
// ── Logo de la empresa ──────────────────────────────────────────────────
export const myOrganizationLogoUploadUrlRequestSchema = adminBrandLogoUploadUrlRequestSchema;
export const myOrganizationLogoUploadUrlResponseSchema = adminBrandLogoUploadUrlResponseSchema;
export const myOrganizationLogoCommitRequestSchema = adminBrandLogoCommitRequestSchema;
export const myOrganizationLogoCommitResponseSchema = adminOrgLogoCommitResponseSchema;
// ── Marcas ──────────────────────────────────────────────────────────────
export const myOrganizationBrandParamsSchema = z.object({ brandId: z.string().uuid() });
export const myOrganizationBrandCreateRequestSchema = adminBrandCreateRequestSchema;
// PATCH: hoy sólo el nombre. `.strict()` para que un cliente que mande el
// código de marca o el correo del handoff reciba 400 y no un silencio.
export const myOrganizationBrandUpdateRequestSchema = z
    .object({
    name: z.string().trim().min(1).max(120),
})
    .strict();
export const myOrganizationBrandResponseSchema = z.object({
    brand: myOrganizationBrandSchema,
});
export const myOrganizationBrandLogoUploadUrlRequestSchema = adminBrandLogoUploadUrlRequestSchema;
export const myOrganizationBrandLogoCommitRequestSchema = adminBrandLogoCommitRequestSchema;
// El commit de logo de marca responde la marca entera (con `isDefault`),
// igual que crear o renombrar.
export const myOrganizationBrandLogoCommitResponseSchema = myOrganizationBrandResponseSchema;
//# sourceMappingURL=organization-branding.js.map